package top.wcpe.allincore.dsl.compiler.codegen

import top.wcpe.allincore.dsl.compiler.ast.ExprAst
import top.wcpe.allincore.dsl.compiler.ast.SubscribeBlockAst
import top.wcpe.allincore.dsl.compiler.codegen.internal.ExprSerializer
import top.wcpe.allincore.dsl.ir.model.UiSubscribeBlock

/**
 * Stage B：subscribe AST 到 IR 订阅条目列表。
 *
 * 把所有 subscribe 块中的 item 平展为 [UiSubscribeBlock] 列表。
 */
class SubscribeEmitter {

    fun emit(blocks: List<SubscribeBlockAst>): List<UiSubscribeBlock> {
        val out = mutableListOf<UiSubscribeBlock>()
        for (block in blocks) {
            for (item in block.items) {
                out += emitItem(item)
            }
        }
        return out
    }

    private fun emitItem(item: SubscribeBlockAst.Item): UiSubscribeBlock {
        val handler = item.handler
        val paramName: String
        val bodyBytes: ByteArray
        when (handler) {
            is ExprAst.FunRefExpr -> {
                paramName = ""
                bodyBytes = ExprSerializer.serializeExpr(handler)
            }
            is ExprAst.LambdaExpr -> {
                paramName = handler.params.firstOrNull() ?: ""
                bodyBytes = ExprSerializer.serializeActionBody(handler.body)
            }
            else -> {
                // 语义层已校验，此处兜底
                paramName = ""
                bodyBytes = ExprSerializer.serializeExpr(handler)
            }
        }
        return UiSubscribeBlock(item.namespace, item.topic, paramName, bodyBytes)
    }
}
